<p>
  <ng-container *ngIf="chartDescription.evaluationCode === 'draw'">
    <ng-container i18n="@@dexterity_patientStatusSummaryIntro1"
      >Entre le <strong> {{ startDate }} </strong> et le
      <strong> {{ endDate }} </strong>
      <strong>{{
        patient.firstName + " " + patient.lastName | uppercase
      }}</strong>
      a réalisé
      <strong> {{ chartDescription.measuringPointsTotal }} </strong> test(s) de
      dextérité. </ng-container
    ><br /><br />
    <ng-container
      *ngIf="hasFeaturesGroups() && chartDescription.measuringPointsTotal > 0"
    >
      <div i18n="@@dexterity_patientStatusSummaryIntro2">
        Sur cette période, les résultats de dextérité de
        <strong>{{
          patient.firstName + " " + patient.lastName | uppercase
        }}</strong>
        sont les suivants :
      </div>

      <ng-container
        *ngFor="let featuresGroup of chartDescription.featuresGroups"
      >
        <div *ngIf="hasFeaturesInGroup(featuresGroup)">
          <span *ngIf="featuresGroup.label"> {{ featuresGroup.label }} :</span>

          <ul class="list">
            <ng-container
              *ngFor="
                let feature of getShownFeatures(featuresGroup);
                let i = index
              "
            >
              <li>
                <span
                  *ngIf="
                    feature.featureId === 'draw-left-pwd-mean' ||
                    feature.featureId === 'draw-right-pwd-mean'
                  "
                  i18n="@@dexterity_patientStatusSummary_precision"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        feature.data,
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  en précision (<strong>
                    {{ getProgressionValueStartDate(feature) }}</strong
                  >
                  mm à
                  <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                  mm)</span
                >
                <span
                  *ngIf="
                    feature.featureId === 'draw-left-ct-mean' ||
                    feature.featureId === 'draw-right-ct-mean'
                  "
                  i18n="@@dexterity_patientStatusSummary_time"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        feature.data,
                        feature.isPercentage
                      )
                    }}%</strong
                  >de la durée moyenne de dessin (<strong>
                    {{ getProgressionValueStartDate(feature) }}</strong
                  >
                  à
                  <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                  )</span
                >
                <span
                  *ngIf="
                    feature.featureId === 'draw-left-ds-mean' ||
                    feature.featureId === 'draw-right-ds-mean'
                  "
                  i18n="@@dexterity_patientStatusSummary_speed"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        feature.data,
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  de la vitesse moyenne de dessin (<strong>
                    {{ getProgressionValueStartDate(feature) }}</strong
                  >
                  cm/s
                  <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                  cm/s)</span
                >
              </li>
            </ng-container>
          </ul>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="chartDescription.evaluationCode === 'vision'">
    <ng-container i18n="@@vision_patientStatusSummaryIntro1"
      >Entre le <strong> {{ startDate }} </strong> et le
      <strong> {{ endDate }} </strong>
      <strong>{{
        patient.firstName + " " + patient.lastName | uppercase
      }}</strong>
      a réalisé
      <strong> {{ chartDescription.measuringPointsTotal }} </strong>test(s)
      d’acuité visuelle. </ng-container
    ><br /><br />
    <ng-container
      *ngIf="hasFeaturesGroups() && chartDescription.measuringPointsTotal > 0"
    >
      <div i18n="@@vision_patientStatusSummaryIntro2">
        Sur cette période, les résultats de l'acuité visuelle à faible contraste
        de
        <strong>{{
          patient.firstName + " " + patient.lastName | uppercase
        }}</strong>
        sont les suivants :
      </div>

      <ng-container *ngIf="hasFeaturesGroups()">
        <ng-container
          *ngFor="let featuresGroup of chartDescription.featuresGroups"
        >
          <div *ngIf="hasFeaturesInGroup(featuresGroup)">
            <span *ngIf="featuresGroup.label"> {{ featuresGroup.label }} </span>

            <ul class="list">
              <ng-container
                *ngFor="
                  let feature of getShownFeatures(featuresGroup);
                  let i = index
                "
              >
                <li>
                  <span
                    *ngIf="feature.featureId === 'vision-monol-monoyer'"
                    i18n="@@vision_patientStatusSummary_leftEyeAcuity"
                    >Une variation de
                    <strong
                      >{{
                        chartService.getProgression(
                          feature.data,
                          feature.isPercentage
                        )
                      }}%</strong
                    >
                    de l’acuité œil gauche (<strong>
                      {{ getProgressionValueStartDate(feature) }}</strong
                    >
                    à
                    <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                    )</span
                  >
                  <span
                    *ngIf="feature.featureId === 'vision-monor-monoyer'"
                    i18n="@@vision_patientStatusSummary_rightEyeAcuity"
                    >Une variation de
                    <strong
                      >{{
                        chartService.getProgression(
                          feature.data,
                          feature.isPercentage
                        )
                      }}%</strong
                    >
                    de l’acuité œil droit (<strong>
                      {{ getProgressionValueStartDate(feature) }}</strong
                    >
                    à
                    <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                    )</span
                  >
                  <span
                    *ngIf="feature.featureId === 'vision-bin-monoyer'"
                    i18n="@@vision_patientStatusSummary_binocAcuity"
                    >Une variation de
                    <strong
                      >{{
                        chartService.getProgression(
                          feature.data,
                          feature.isPercentage
                        )
                      }}%</strong
                    >
                    de l’acuité binoculaire (<strong>
                      {{ getProgressionValueStartDate(feature) }}</strong
                    >
                    à
                    <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                    )</span
                  >
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="chartDescription.evaluationCode === 'cps'">
    <ng-container i18n="@@cognition_patientStatusSummaryIntro1"
      >Entre le <strong> {{ startDate }} </strong> et le
      <strong> {{ endDate }} </strong>
      <strong>{{
        patient.firstName + " " + patient.lastName | uppercase
      }}</strong>
      a réalisé
      <strong> {{ chartDescription.measuringPointsTotal }} </strong>test(s) de
      cognition mobile. </ng-container
    ><br /><br />
    <ng-container
      *ngIf="hasFeaturesGroups() && chartDescription.measuringPointsTotal > 0"
    >
      <div i18n="@@cognition_patientStatusSummaryIntro2">
        Sur cette période, les résultats cognitifs de
        <strong>
          {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
        >
        sont les suivants :
      </div>

      <ng-container *ngIf="hasFeaturesGroups()">
        <ng-container
          *ngFor="let featuresGroup of chartDescription.featuresGroups"
        >
          <div *ngIf="hasFeaturesInGroup(featuresGroup)">
            <span *ngIf="featuresGroup.label"> {{ featuresGroup.label }} </span>

            <ul class="list">
              <ng-container
                *ngFor="
                  let feature of getShownFeatures(featuresGroup);
                  let i = index
                "
              >
                <li>
                  <span
                    *ngIf="feature.featureId === 'cps-std_ar-rt-mean'"
                    i18n="@@cognition_patientStatusSummary_processingSpeed"
                    >Une variation de
                    <strong
                      >{{
                        chartService.getProgression(
                          feature.data,
                          feature.isPercentage
                        )
                      }}%</strong
                    >
                    de la vitesse de traitement (<strong>
                      {{ getProgressionValueStartDate(feature) }}</strong
                    >
                    ms à
                    <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                    ms)</span
                  >
                  <span
                    *ngIf="feature.featureId === 'cps-std-acc'"
                    i18n="@@cognition_patientStatusSummary_correctPercentage"
                    >Une variation de
                    <strong
                      >{{
                        chartService.getProgression(
                          feature.data,
                          feature.isPercentage
                        )
                      }}%</strong
                    >
                    du taux de réponses correctes (<strong>
                      {{ getProgressionValueStartDate(feature) }}</strong
                    >& à
                    <strong>{{ getProgressionValueEndDate(feature) }}</strong
                    >% )</span
                  >
                  <span
                    *ngIf="feature.featureId === 'cps-std-crc'"
                    i18n="@@cognition_patientStatusSummary_correctAnswers"
                    >Une variation de
                    <strong
                      >{{
                        chartService.getProgression(
                          feature.data,
                          feature.isPercentage
                        )
                      }}%</strong
                    >
                    dans le nombre de réponses correctes (<strong>
                      {{ getProgressionValueStartDate(feature) }}</strong
                    >
                    à
                    <strong>{{ getProgressionValueEndDate(feature) }}</strong>
                    )</span
                  >
                </li>
              </ng-container>
            </ul>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="chartDescription.evaluationCode === 'perimeter'">
    <ng-container i18n="@@perimeter_patientStatusSummaryIntro1"
      >Entre le <strong> {{ startDate }} </strong> et le
      <strong> {{ endDate }} </strong>
      <strong>{{
        patient.firstName + " " + patient.lastName | uppercase
      }}</strong>
      a réalisé
      <strong> {{ chartDescription.measuringPointsTotal }} </strong>test(s) du
      périmètre de marche, dont
      <strong>
        {{ getResumeNbValues(chartDescription.resume[0]) }} sans aide à la
        marche</strong
      >
      et
      <strong>
        {{ getResumeNbValues(chartDescription.resume[1]) }} avec aide à la
        marche</strong
      > </ng-container
    ><br /><br />

    <ng-container *ngFor="let filter of chartDescription.filters">
      <div *ngIf="hasFilteredFeatures(filter)">
        <span
          *ngIf="filter.value === 0"
          i18n="@@perimeter_patientStatusSummaryIntro_noWalkingAid"
          >Sur cette période, les résultats du périmètre de marche sans aide de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>
        <span
          *ngIf="filter.value === 1"
          i18n="@@perimeter_patientStatusSummaryIntro_unilateralAid"
          >Sur cette période, les résultats du périmètre de marche avec aide
          unilatérale de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>
        <span
          *ngIf="filter.value === 2"
          i18n="@@perimeter_patientStatusSummaryIntro_bilateralAid"
          >Sur cette période, les résultats du périmètre de marche avec aide
          bilatérale de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>
        <span
          *ngIf="filter.value === 3"
          i18n="@@perimeter_patientStatusSummaryIntro_humanAid"
          >Sur cette période, les résultats du périmètre de marche avec aidant
          de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>

        <ul class="list">
          <ng-container
            *ngFor="let featuresGroup of chartDescription.featuresGroups"
          >
            <ng-container
              *ngFor="
                let feature of getShownFeatures(featuresGroup, filter);
                let i = index
              "
            >
              <li>
                <span
                  *ngIf="feature.featureId === 'perimeter-sgps-wd'"
                  i18n="@@perimeter_patientStatusSummary_distance"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        getFilteredFeatureData(feature, filter),
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  du périmètre (<strong>
                    {{ getProgressionValueStartDate(feature, filter) }}</strong
                  >
                  m à
                  <strong>{{
                    getProgressionValueEndDate(feature, filter)
                  }}</strong>
                  m)</span
                >
                <span
                  *ngIf="feature.featureId === 'perimeter-sgps-ws-mean'"
                  i18n="@@perimeter_patientStatusSummary_speed"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        getFilteredFeatureData(feature, filter),
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  de la vitesse moyenne (<strong>
                    {{ getProgressionValueStartDate(feature, filter) }}</strong
                  >
                  km/h à
                  <strong>{{
                    getProgressionValueEndDate(feature, filter)
                  }}</strong>
                  km/h)</span
                >
                <span
                  *ngIf="feature.featureId === 'perimeter-twt'"
                  i18n="@@perimeter_patientStatusSummary_duration"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        getFilteredFeatureData(feature, filter),
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  de la durée (<strong>
                    {{ getProgressionValueStartDate(feature, filter) }}</strong
                  >
                  min à
                  <strong>{{
                    getProgressionValueEndDate(feature, filter)
                  }}</strong>
                  min)</span
                >
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="chartDescription.evaluationCode === '6mwt'">
    <ng-container i18n="@@endurance_patientStatusSummaryIntro1"
      >Entre le <strong> {{ startDate }} </strong> et le
      <strong> {{ endDate }} </strong>
      <strong>{{
        patient.firstName + " " + patient.lastName | uppercase
      }}</strong>
      a réalisé
      <strong> {{ chartDescription.measuringPointsTotal }} </strong>test(s)
      d’endurance, dont
      <strong>
        {{ getResumeNbValues(chartDescription.resume[0]) }} sans aide à la
        marche</strong
      >
      et
      <strong>
        {{ getResumeNbValues(chartDescription.resume[1]) }} avec aide à la
        marche</strong
      > </ng-container
    ><br /><br />

    <ng-container *ngFor="let filter of chartDescription.filters">
      <div *ngIf="hasFilteredFeatures(filter)">
        <span
          *ngIf="filter.value === 0"
          i18n="@@endurance_patientStatusSummaryIntro_noWalkingAid"
          >Sur cette période, les résultats d’endurance sans aide de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>
        <span
          *ngIf="filter.value === 1"
          i18n="@@endurance_patientStatusSummaryIntro_unilateralAid"
          >Sur cette période, les résultats d’endurance avec aide unilatérale de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>
        <span
          *ngIf="filter.value === 2"
          i18n="@@endurance_patientStatusSummaryIntro_bilateralAid"
          >Sur cette période, les résultats d’endurance avec aide bilatérale de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>
        <span
          *ngIf="filter.value === 3"
          i18n="@@endurance_patientStatusSummaryIntro_humanAid"
          >Sur cette période, les résultats d’endurance avec aidant de
          <strong>
            {{ patient.firstName + " " + patient.lastName | uppercase }}</strong
          >
          sont les suivants :
        </span>

        <ul class="list">
          <ng-container
            *ngFor="let featuresGroup of chartDescription.featuresGroups"
          >
            <ng-container
              *ngFor="
                let feature of getShownFeatures(featuresGroup, filter);
                let i = index
              "
            >
              <li>
                <span
                  *ngIf="feature.featureId === '6mwt-6min_sgps-wd'"
                  i18n="@@endurance_patientStatusSummary_distance"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        getFilteredFeatureData(feature, filter),
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  de la distance parcourue en 6 minutes(<strong>
                    {{ getProgressionValueStartDate(feature, filter) }}</strong
                  >
                  m à
                  <strong>{{
                    getProgressionValueEndDate(feature, filter)
                  }}</strong>
                  m)</span
                >
                <span
                  *ngIf="feature.featureId === '6mwt-6min_sgps-ws-mean'"
                  i18n="@@endurance_patientStatusSummary_speed"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        getFilteredFeatureData(feature, filter),
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  de la vitesse moyenne à 6 minutes (<strong>
                    {{ getProgressionValueStartDate(feature, filter) }}</strong
                  >
                  km/h à
                  <strong>{{
                    getProgressionValueEndDate(feature, filter)
                  }}</strong>
                  km/h)</span
                >
                <span
                  *ngIf="feature.featureId === '6mwt-twt'"
                  i18n="@@endurance_patientStatusSummary_duration"
                  >Une variation de
                  <strong
                    >{{
                      chartService.getProgression(
                        getFilteredFeatureData(feature, filter),
                        feature.isPercentage
                      )
                    }}%</strong
                  >
                  du temps total de marche (<strong>
                    {{ getProgressionValueStartDate(feature, filter) }}</strong
                  >
                  min à
                  <strong>{{
                    getProgressionValueEndDate(feature, filter)
                  }}</strong>
                  min)</span
                >
              </li>
            </ng-container>
          </ng-container>
        </ul>
      </div>
    </ng-container>
  </ng-container>
</p>
